import React from 'react';
import {SettingCard} from "./settingCard"

function settings() {
  return (
    <div >
      <SettingCard />
    </div>
  );
}

export default settings;